import { lazy } from 'react'

export const AddingReleaseStep1Page = lazy(() => import('./AddingReleaseStep1Page'))
    